import { render } from "./studentEdit.vue?vue&type=template&id=d5c89b04&scoped=true"
import script from "./studentEdit.vue?vue&type=script&lang=js"
export * from "./studentEdit.vue?vue&type=script&lang=js"

import "./studentEdit.vue?vue&type=style&index=0&id=d5c89b04&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c89b04"]])

export default __exports__